import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import logo from '../assets/logo.png';
import './Sidebar.css';

const Sidebar = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [expandedSections, setExpandedSections] = useState({});

  const isActive = (path) => location.pathname === path;

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const toggleSection = (category) => {
    setExpandedSections(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  // Procesar módulos para ordenación e interleaving
  const sidebarItems = [];
  if (user?.modules && user.modules.length > 0) {
    user.modules.forEach(module => {
      if (module.is_standalone) {
        sidebarItems.push({
          type: 'standalone',
          module
        });
      } else {
        const category = module.category || 'Otros';
        let existingCategory = sidebarItems.find(item => item.type === 'category' && item.category === category);
        if (!existingCategory) {
          existingCategory = {
            type: 'category',
            category,
            modules: []
          };
          sidebarItems.push(existingCategory);
        }
        existingCategory.modules.push(module);
      }
    });
  }

  // Inicializar secciones expandidas basadas en la ruta actual
  useEffect(() => {
    const initialExpanded = {};
    sidebarItems.forEach(item => {
      if (item.type === 'category') {
        const hasActiveChild = item.modules.some(m => isActive(m.path));
        if (hasActiveChild) {
          initialExpanded[item.category] = true;
        }
      }
    });
    setExpandedSections(prev => ({ ...initialExpanded, ...prev }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.modules]); // Solo al cargar el usuario o módulos

  return (
    <>
      {/* Botón hamburguesa - solo visible en mobile */}
      <button className="hamburger-btn" onClick={toggleSidebar}>
        ☰
      </button>

      {/* Overlay para cerrar el sidebar al hacer click */}
      {isOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <button className="sidebar-close-btn" onClick={toggleSidebar}>
          ✕
        </button>

        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src={logo} alt="TRANSIAPP" className="app-logo" />
          </div>
        </div>

        <nav className="sidebar-nav">
          {sidebarItems.map((item, index) => {
            if (item.type === 'standalone') {
              const { module } = item;
              return (
                <Link
                  key={module.id}
                  to={module.path}
                  className={`nav-item ${isActive(module.path) ? 'active' : ''}`}
                  onClick={() => setIsOpen(false)}
                  style={{ display: 'flex', textDecoration: 'none' }}
                >
                  <span className="nav-icon">{module.icon}</span>
                  <span className="nav-text">{module.label}</span>
                </Link>
              );
            } else {
              const { category, modules } = item;
              return (
                <div key={category} className={`nav-section ${!expandedSections[category] ? 'collapsed' : ''}`}>
                  <div 
                    className="nav-section-header" 
                    onClick={() => toggleSection(category)}
                  >
                    <h3 className="nav-section-title">{category}</h3>
                    <span className="section-toggle-icon">▲</span>
                  </div>
                  <div className="nav-section-content">
                    {modules.map((module) => (
                      <Link
                        key={module.id}
                        to={module.path}
                        className={`nav-item ${isActive(module.path) ? 'active' : ''}`}
                        onClick={() => setIsOpen(false)}
                      >
                        <span className="nav-icon">{module.icon}</span>
                        <span className="nav-text">{module.label}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              );
            }
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-role">
            {user?.role === 'superadmin' && '🔐 Superadmin'}
            {user?.role === 'admin' && '👨‍💼 Admin'}
            {user?.role === 'user' && '👤 Usuario'}
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
